import React from 'react'
import styles from './Sex.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton'
import { OtherButton } from '../../../Common/CtaButton/OtherButton'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'

export const Sex = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    return (
        <div className={styles.wrapper}>
            <div>
                <FormTitle
                    formTitleText="性別を教えてください"
                    dataViewLabel={dataViewLabel('EF_StepForm_性別')}
                    dataClickLabel={dataClickLabel('EF_StepForm_性別-戻る')}
                />
                <div className={styles.selectionWrapper}>
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step3/man-mark.png"
                        imageAlt="男性画像"
                        text="男性"
                        formKey={'sex'}
                        formValue={'man'}
                        displayFormKey={'sex'}
                        displayFormValue={'男性'}
                        dataClickLabel={dataClickLabel('EF_StepForm_性別-男性')}
                    />
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step3/woman-mark.png"
                        imageAlt="女性"
                        text="女性"
                        formKey={'sex'}
                        formValue={'woman'}
                        displayFormKey={'sex'}
                        displayFormValue={'女性'}
                        dataClickLabel={dataClickLabel('EF_StepForm_性別-女性')}
                    />
                    <OtherButton
                        text="その他"
                        formKey={'sex'}
                        formValue={'other'}
                        displayFormKey={'sex'}
                        displayFormValue={'その他'}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_性別-その他'
                        )}
                    />
                </div>
                <p className={styles.loginText}>
                    <a
                        href="/login"
                        data-click-label={dataClickLabel(
                            'EF_StepForm_性別-会員登録済み'
                        )}
                    >
                        会員登録済みの方はこちら
                    </a>
                </p>
            </div>
        </div>
    )
}
